<template>
    <div class="page light">

        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title" style="">Serviços</div>
                <div class="right">
                    <a  class="link hidden">
                        <i class="las la-shopping-cart"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="page-content content-area pt-60 bottom-sp60" v-bind:class="{'disabled': $root.user.confirmacao == 0}">
                    
            <div class="container hidden-xs hidden-md">
                <h2>Serviços</h2>
            </div>


            <div class="container">
                <button v-on:click="$root.go('CadastrarServicos', JSON.stringify({'agendaCod':form.agendaCod, 't': Math.random()}))" type="button" class="button button-outline mb-10">
                    <i class="las la-plus"></i>
                    Adicionar novo serviço
                </button>
            </div>

            <div class="empty" v-if="data.itens.length == 0 && data.loaded" style="margin-top: 30%">
                <center>
                    <img src="static/images/empty.png" style="width: 80%">
                    <p class="mt-0 pt-0">
                        <i class="las la-times"></i>
                        Nenhum resultado encontrado.
                    </p>
                </center>
            </div>

            <div class="container notification-list">
                <ul>

                    <li v-for="(item, index) in data.itens" :key="item.cod">
                        <h6 class="item-title" style="font-weight: 600">
                            <i class="text-success las la-circle"></i> {{item.nome}}
                            <br>
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Valor: R$ {{item.valor | toMoney}}
                                <span style="margin-left: 2px" v-if="item.visivel == 1" class="badge color-green">
                                    Ativo
                                </span>
                                <span style="margin-left: 2px" v-if="item.visivel == 0" class="badge color-orange">
                                    Desativado
                                </span>                                       
                            </small>
                            <br>
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Duração: {{item.duracao}} minuto(s)
                            </small>
                            <br>
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Intervalo: {{item.intervalo}} minuto(s)
                            </small>                            
                            <br>                            
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Última modificação: {{item.atualizacao | formatDate}}
                            </small>
                        </h6>
                        <div class="item-text" style="font-size: 12px; padding-top: 10px; text-align: right;">
                            <button v-on:click="$root.go('EditarServicos', JSON.stringify({'c': item.cod, 't': Math.random()}))" type="button" class="button button-outline color-gray" style="display: inline-block; width: auto; font-size: 12px; height: 20px; line-height: 16px">
                                <i class="las la-edit"></i> 
                                Editar
                            </button>
                            <button v-on:click="del(item.cod)" type="button" class="button button-outline color-red" style="display: inline-block; width: auto; font-size: 12px; margin-left: 5px; height: 20px; line-height: 16px">
                                <i class="las la-trash-alt"></i> 
                                Apagar
                            </button>  

                        </div>
                    </li>


<!--                     <li >
                        <h6 class="item-title" style="font-weight: 600">
                            <i class="text-success las la-circle"></i> Procedimento de Teste
                            <br>
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Valor: R$ 220,00
                            </small>
                            <br>
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Duração: 60 minutos
                            </small>
                            <br>
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Intervalo: 30 minutos
                            </small>                            
                            <br>                            
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Última modificação: 12/12/2021 13:13h
                            </small>
                        </h6>
                        <div class="item-text" style="font-size: 12px; padding-top: 10px; text-align: right;">
                            <button  type="button" class="button button-outline color-gray" style="display: inline-block; width: auto; font-size: 12px; height: 20px; line-height: 16px">
                                <i class="las la-edit"></i> 
                                Editar
                            </button>
                            <button v-on:click="del()" type="button" class="button button-outline color-red" style="display: inline-block; width: auto; font-size: 12px; margin-left: 5px; height: 20px; line-height: 16px">
                                <i class="las la-trash-alt"></i> 
                                Apagar
                            </button>  

                        </div>
                    </li>
                    <li >
                        <h6 class="item-title" style="font-weight: 600">
                            <i class="text-success las la-circle"></i> Botox
                            <br>
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Valor: R$ 650,00
                            </small>
                            <br>
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Duração: 60 minutos
                            </small>
                            <br>
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Intervalo: 30 minutos
                            </small>                            
                            <br>                            
                            <small style="font-weight: 400; color: #666;">
                                <i class="las la-clock"></i> Última modificação: 12/12/2021 13:13h
                            </small>
                        </h6>
                        <div class="item-text" style="font-size: 12px; padding-top: 10px; text-align: right;">
                            <button  type="button" class="button button-outline color-gray" style="display: inline-block; width: auto; font-size: 12px; height: 20px; line-height: 16px">
                                <i class="las la-edit"></i> 
                                Editar
                            </button>
                            <button v-on:click="del()" type="button" class="button button-outline color-red" style="display: inline-block; width: auto; font-size: 12px; margin-left: 5px; height: 20px; line-height: 16px">
                                <i class="las la-trash-alt"></i> 
                                Apagar
                            </button>  

                        </div>
                    </li>      -->              

                </ul>
            </div>                   
        </div>
        
        <!-- <Toolbar></Toolbar> -->
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'Servicos',
    components: {
        'Toolbar': Toolbar,
        'Top': Top
    },          
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },      
    data () {
        var self = this;
        return {
            "data":                 {
                "pages":            [],
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "page":             1,
                "pesquisa":         "",
                "agendaCod":        "",
                // "tipo":             "especialidade"
            }              
        }
    },
    methods: {   
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/catalogo.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.$forceUpdate();
                    loading.hide();
                    resolve(response.data.result);
                    self.$root.scrollTop();
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/catalogo.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }        
    },
    beforeMount: function(e){
    },    
    activated: function() {
        var self = this;

        if (!self.$route.query.c) {
            self.$root.back();
            return false;
        }
        self.form.agendaCod = self.$route.query.c;

        self.get();
    },
    mounted: function() {
        var self            = this;
    }     
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
   
    .tag-list {
        margin-bottom: 0px !important;
        margin-top: 0px;
    }

    .item-title {
        margin-bottom: 0px !important;
        line-height: 130%;
        font-weight: 500;
        font-size: 16px;
    }
    .chip-label {
        font-weight: bold;
        font-size: 12px !important;
    }
    .chip {
        line-height: 18px !important;
        height: auto !important;
        min-height: 18px !important;
        /*padding-bottom: 0px;*/
        /*padding-top: 0px;*/
        margin-top: -4px;
        margin-left: -2px;
        margin-bottom: 5px;
    }
    .dz-media {
        margin-bottom: 5px !important;
    }
    .tabbar.tab-style-2 .tab-link:after {
        display: none !important;
    }

    .banner {
        background: var(--f7-theme-color);
        padding: 20px;
        margin-bottom: 30px;
    }

    .banner h4 {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }

    .banner p {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }    

    .img-perfil {
        width: 50px;
        height: 50px;
        background-size: cover;
        background-position: center;
        border: 1px solid #ddd;
        border-radius: 6px;
        display: inline-block;
    }    

    .col-50-grid {
      margin: 0;
      display: grid;
      grid-template-rows: 1fr auto;
      margin-bottom: 10px;
      break-inside: avoid;    
    }

    .row-grid {
      column-count: 2;
      column-gap: 20px;
    }
  
    .item-bx.item-grid {
        margin-bottom: 15px;
    }         

    .categories-bx.active {
        background: #f8b832 !important;
        color: #222 !important;
    }

    .cart-list-area {
        padding-left: 0;
        padding-right: 0;
    }

    .cart-list {
        overflow: hidden;
        margin: 0;
    }

    .cart-item {
        background-color: #fff;
        overflow: unset;
        margin: 6px 0;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0px;        
    }        
   
    .cart-item .item-inner {
        background-color: #fff;
        padding: 12px 30px;
    }   

    .cart-item .item-media {
        min-width: 95px !important;
        width: 95px;
        position: relative;
        padding: 0;
        border-radius: 16px;
        overflow: hidden;
        margin-right: 20px;
        height: 115px;
        align-items: flex-start;
        height: 105px;
    }

    .cart-item .item-media img {
        width: 100%;
    }

    .cart-item .item-media .item-price {
        background-color: var(--f7-theme-color);
        color: #fff;
        position: absolute;
        bottom: 0;
        margin: 0;
        width: 100%;
        left: 0;
        text-align: center;
        font-weight: 500;
        font-size: 16px;
        padding: 5px;
        border-radius: 16px;
        box-sizing: border-box;
    }

    .cart-item .item-info {
        width: 100%;
        justify-content: space-between;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 5px 0;
        box-sizing: border-box;
    }

    .cart-item .item-foot {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .cart-item .item-foot .item-total {
        margin: 0;
        font-weight: 500;
        font-size: 16px;
    }                        

    .cart-item .item-content {
        padding-left: 0;
        transition: all 0.5s;
    }

    .cart-item .item-head .category {
        margin: 0;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
    }

    .cart-item .item-title a {
        color: #000;
        word-break: break-word;
        white-space: break-spaces;
        text-overflow: ellipsis;
        display: block;
        line-height: 130%;
    }

    .cart-item .item-title {
        font-weight: 500;
        margin: 0 0 10px;
    }        

    .cart-item .item-media div {
        width: 100%;
        height: 100%;
        background-size: cover !important;
        background-position: center;
        background: #efefef;
        border-radius: 6px;
    }

    .button-round {
        border-radius: 20px !important;
    }

    .badge-large {
        padding: 15px;
    }

    .badge-outline:not(.color-green) {
        background: transparent !important;
        border: 2px solid #064972 !important;
        color: #064972;
    }

    .badge.color-secondary {
        border: 2px solid #064972 !important;
    }

    .badge.color-primary {
        border: 2px solid #0f8cd5 !important;
    }    

    .badge.color-green:not(.badge-outline) {
        border: 2px solid #4cd964 !important;
    }

    .badge-outline.color-green {
        background: transparent !important;
        border: 2px solid #4cd964 !important;
        color: #4cd964;
    }    

    .container {
        padding-left: 15px !important;
        padding-right: 15px !important;
    }

    .button-fill.color-grey {
        background: #ddd !important;
        color: #666 !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Servicos.vue